import { AppActionTypes } from '@console/actions/actionType';
import type { AppAction } from '@console/actions/actionType';
import type { LocalProject } from '@console/reducers/projects';
import type { Reducer } from 'react';
import { combineReducers } from 'redux';

const name: Reducer<
  NonNullable<LocalProject['marketingIndustry']>['name'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.marketingIndustry?.name ?? null;
    default:
      return state;
  }
};

const urlCode: Reducer<
  NonNullable<LocalProject['marketingIndustry']>['urlCode'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.marketingIndustry?.urlCode ?? null;
    default:
      return state;
  }
};

export const marketingIndustry = combineReducers({
  name,
  urlCode
});
